import React, { forwardRef, useMemo, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useEffect } from "react";

const BasicTournamentsLobby = (props) => {
  const { t } = props
  const columns = useMemo(() => props.columns, [props.columns]);
  //const data = useMemo(() => props.data, []);    
  const [data, setData] = useState(props.data)

  useEffect(() => {
    setData(props.data)
  }, [props.data])


  return (<>

    <div>
      {props.data.map((tournament) => {
        return (
          <div className="col-12 col-md-6 col-lg-3" key={tournament.id}>
            <div className="card">
              <div className="card-header">
                {tournament.cms.summary_title}
              </div>
              <div className="card-body"> 
                <div dangerouslySetInnerHTML={{ __html: tournament.cms.summary_body }} />
              
              <button  type="button" className="btn btn-primary"  onClick={() => props.handleClick(tournament)}>{t("Details")}</button>
              </div>
            </div>
          </div>
        );
      })}

    </div></>
  )
}

export default withTranslation()(BasicTournamentsLobby);
